import { createAction, props } from '@ngrx/store';
import { INotificationMessage } from '@core/interfaces';

export const NOTIFICATION_SHOW = createAction('[Notification] Show', props<{ notification: INotificationMessage }>());
export const SERVICE_FAILURE = createAction('[Notification] Service Failure', props<{ notification: INotificationMessage }>());
export const NOTIFICATION_CLEAR = createAction('[Notification] Clear');

export const NOTIFICATION_SUBSCRIBE = createAction('[Notification] Subscribe', props<{ token: string }>());


